<template>
  <div class="bg-white rounded-xl border border-gray-200 p-4 shadow-sm hover:shadow-md transition-all">
    <div class="flex gap-3">
      <!-- Icon -->
      <div class="w-12 h-12 rounded-lg bg-cyan-50 flex items-center justify-center shrink-0">
        <font-awesome-icon :icon="['fas', 'file-lines']" class="text-cyan-600" />
      </div>

      <div class="flex-1 min-w-0">
        <!-- Title -->
        <p class="text-sm font-semibold text-gray-900">{{ assignment.name }}</p>

        <!-- Category -->
        <p v-if="assignment.categoryName" class="text-xs text-cyan-600 mt-0.5">
          {{ assignment.categoryName }}
        </p>

        <!-- Description -->
        <p v-if="description" class="text-sm text-gray-500 mt-1 line-clamp-2">
          {{ description }}
        </p>

        <!-- Due date + submission progress -->
        <div class="flex items-center justify-between mt-2.5">
          <p v-if="formattedDueDate" class="text-xs text-gray-400">
            Due: {{ formattedDueDate }}
          </p>
          <div v-else />

          <!-- Teacher: submission progress -->
          <div v-if="isTeacher && assignment.totalStudents > 0" class="flex items-center gap-1.5">
            <svg class="w-4 h-4 -rotate-90" viewBox="0 0 36 36">
              <circle
                cx="18" cy="18" r="14"
                fill="none" stroke="currentColor"
                stroke-width="4"
                class="text-gray-200"
              />
              <circle
                cx="18" cy="18" r="14"
                fill="none" stroke="currentColor"
                stroke-width="4"
                class="text-cyan-600"
                :stroke-dasharray="`${progress * 88} 88`"
                stroke-linecap="round"
              />
            </svg>
            <span class="text-xs font-medium text-cyan-600">
              {{ assignment.submissionCount }}/{{ assignment.totalStudents }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import type { PostAssignment } from '@/api'

const props = defineProps<{
  assignment: PostAssignment
  description?: string
  isTeacher?: boolean
}>()

const progress = computed(() => {
  if (!props.assignment.totalStudents) return 0
  return props.assignment.submissionCount / props.assignment.totalStudents
})

const formattedDueDate = computed(() => {
  if (!props.assignment.dateDue) return null
  try {
    const d = new Date(props.assignment.dateDue)
    return d.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' })
  } catch {
    return props.assignment.dateDue
  }
})
</script>
